import { colors, ApButtonIcon } from '@alixpartners/ui-components';
import { animated } from 'react-spring';
import styled from 'styled-components';

import { BACKGROUND_COLORS, STATE_COLORS } from './common';

import { TFileStatus } from '../../types';

interface IStateDependentDiv {
  status: TFileStatus;
}

export const Container = styled.div<IStateDependentDiv>`
  display: flex;
  background-color: ${({ status }) => BACKGROUND_COLORS[status]};
  padding: 12px;
  flex-direction: column;
  margin-bottom: 8px;
  box-sizing: border-box;
`;
export const ButtonIcon = styled(ApButtonIcon)`
  margin-left: 8px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  &:first-child {
    margin-right: auto;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }
`;

export const ExpiresMessage = styled.span`
  margin-left: 8px;
  color: ${colors.grey600};
`;

export const Separator = styled.div`
  border-right: 1px solid ${colors.grey300};

  width: 10px;
  height: 24px;
  margin-right: 24px;
`;

export const DeleteWrapper = styled(Wrapper)`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.24px;
  color: #4a4a4a;
  gap: 2px;
  cursor: pointer;
`;

export const DataLoading = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey600};
  display: flex;
  height: 32px;
  align-items: center;
  width: 127px;
`;

export const SessionWrapper = styled.div`
  padding-bottom: 24px;

  &:last-child {
    padding-bottom: 0;
  }
`;

export const Heading = styled.div<IStateDependentDiv>`
  display: flex;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${({ status }) => STATE_COLORS[status]};
  padding: 0 0 12px 16px;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > div {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey500};
  margin-right: 8px;
  height: 16px;
`;

export const GroupHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const GroupName = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #4a4a4a;
`;

export const FileRows = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 40px;
`;

export const FileRow = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  color: #4a4a4a;
`;

// Other files list
export const GroupIconBox = styled.div`
  width: 32px;
  height: 34px;
  background: #f1f1f1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
`;

export const OtherFilesContainer = styled.div`
  display: flex;
  background-color: ${colors.grey200};
  flex-direction: column;
  margin-bottom: 8px;
`;

export const OtherFilesHeading = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey500};
  padding: 12px 12px 12px 28px;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

export const MainWrapper = styled(animated.div)`
  overflow: hidden;
`;

export const OtherFilesList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 12px 12px 12px;
  box-sizing: border-box;
  overflow: hidden;

  > div {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
